<div class="page">
  <!-- ===================== HERO HEADER ===================== -->
  <div class="detail-hero">
    <div class="dh-left">
      @if (logoSrc()) {
        <p-avatar [image]="logoSrc()" shape="circle" size="xlarge" styleClass="dh-avatar" />
      } @else {
        <p-avatar [label]="initials(client()?.clientName)" shape="circle" size="xlarge"
          styleClass="dh-avatar brand" />
      }
      <div class="dh-meta">
        <div class="dh-title-row">
          <h2>{{ client()?.clientName || (loading() ? 'Loading…' : 'Client') }}</h2>
          @if (client(); as c) {
            <p-tag [value]="c.isActive ? 'Active' : 'Inactive'"
              [severity]="c.isActive ? 'success' : 'secondary'"
              [icon]="c.isActive ? 'pi pi-check-circle' : 'pi pi-ban'" rounded />
          }
        </div>
        <div class="dh-sub">
          @if (client()?.clientCode) {
            <span class="dh-code"><i class="pi pi-hashtag"></i> {{ client()!.clientCode }}</span>
          }
          @if (client()?.companyName) {
            <span class="dh-company"><i class="pi pi-briefcase"></i> {{ client()!.companyName }}</span>
          }
        </div>
        @if (client(); as c) {
          <div class="dh-chips">
            @if (c.contactPerson) { <p-chip [label]="c.contactPerson" icon="pi pi-user" /> }
            @if (c.email) { <p-chip [label]="c.email" icon="pi pi-envelope" /> }
            @if (c.mobile) { <p-chip [label]="c.mobile" icon="pi pi-phone" /> }
            @if (c.city || c.state) {
              <p-chip [label]="(c.city || '') + (c.state ? (c.city ? ', ' : '') + c.state : '')"
                icon="pi pi-map-marker" />
            }
          </div>
        }
      </div>
    </div>
    <div class="head-actions">
      <p-button label="Edit" icon="pi pi-pencil" styleClass="dh-btn" (onClick)="edit()" />
      <p-button label="Back" icon="pi pi-arrow-left" [text]="true" styleClass="dh-back" (onClick)="back()" />
    </div>
  </div>

  <!-- ===================== TABS ===================== -->
  <div class="card tabs-card">
    <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab value="branches"><i class="pi pi-sitemap"></i> Branches</p-tab>
        <p-tab value="apikeys"><i class="pi pi-key"></i> API Keys</p-tab>
        <p-tab value="callbacks"><i class="pi pi-send"></i> Callbacks</p-tab>
        <p-tab value="payment"><i class="pi pi-credit-card"></i> Payment Config</p-tab>
        <p-tab value="messaging"><i class="pi pi-comments"></i> Messaging</p-tab>
        <p-tab value="portal"><i class="pi pi-lock"></i> Portal Access</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="branches">
          @if (clientId() && activeTab() === 'branches') {
            <app-client-branches [clientId]="clientId()!" />
          }
        </p-tabpanel>
        <p-tabpanel value="apikeys">
          @if (clientId() && activeTab() === 'apikeys') {
            <app-client-api-keys [clientId]="clientId()!" />
          }
        </p-tabpanel>
        <p-tabpanel value="callbacks">
          @if (clientId() && activeTab() === 'callbacks') {
            <app-client-callbacks [clientId]="clientId()!" />
          }
        </p-tabpanel>
        <p-tabpanel value="payment">
          @if (clientId() && activeTab() === 'payment') {
            <app-client-payment-config [clientId]="clientId()!" />
          }
        </p-tabpanel>
        <p-tabpanel value="messaging">
          @if (clientId() && activeTab() === 'messaging') {
            <div class="tab-body">
              <div class="tab-head">
                <div>
                  <h3>Messaging</h3>
                  <p>
                    Which channels each message goes out on for this client. Rows left on
                    <b>Inherit</b> follow the global defaults.
                  </p>
                </div>
              </div>
              <app-messaging-rules lockedScopeType="CLIENT" [lockedScopeId]="clientId()!" />
            </div>
          }
        </p-tabpanel>
        <p-tabpanel value="portal">
          @if (clientId() && activeTab() === 'portal') {
            <div class="tab-body">
              <app-client-portal-users [clientId]="clientId()!" />
            </div>
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
